import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  MenuItem,
  Select,
  Stack,
  Box,
  TextField,
  Typography,
} from "@mui/material";
import { React, useEffect, useState, useRef } from "react";
import { useStyles } from "./styles";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { shadow } from "../../../assets/const";
import CustomExpandMore from "../../../common/CustomExpandMore";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import PersonIcon from "@mui/icons-material/Person";
// import Profile from "../../../assets/images/Header_image/blog1.png";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import useStaff from "../../../Hooks/staff";
import AddEducationInformation, {
  addStaffEducationDetailsSchema,
} from "../AddStaff/EducationInfo/index";
import AddEmployementInformation, {
  addStaffEmploymentDetailsSchema,
} from "../AddStaff/EmploymentInfo/index";
import AddAchivementsInformation, {
  addCertificationInfromationSchema,
} from "../AddStaff/Achivements/index";
import AddCertificationInformation, {
  addStaffCertificationInfromationSchema,
} from "../AddStaff/Certification/index";
import OtherIntrestsInformation from "../AddStaff/OtherInterests/index";
import { Navigate, useLocation, useOutletContext } from "react-router-dom";
import Loader from "../../../common/Loader";
import logout from "../../../assets/images/Sidebar/logout.svg";
import { useNavigate } from "react-router-dom";
import Profile from "../../../assets/images/Sidebar/icons/admit_logo.svg";
import useCourse from "../../../Hooks/course";
import useAuthStore from "../../../Hooks/auth";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { CheckBox } from "@mui/icons-material";
import { toast } from "react-toastify";

const BorderLinearProgress = styled(LinearProgress)(() => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#D1FADF",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "green",
  },
}));

const test =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const number = /^[0]?[0-9]\d{11,13}$/;
const addStaffDetailsSchema = Yup.object().shape({
  firstName: Yup.string().required("* Please enter first name"),
  lastName: Yup.string().required("* Please enter last name "),
  dob: Yup.date()
    .max(new Date(), "*please select  valid DOB")
    .required("* Please select DOB"),
  bloodGroup: Yup.string().required("* Please select blood group"),
  idDepartment: Yup.string().required("*Please select broadcasting group"),
  email: Yup.string()
    .matches(test, "please enter the valid")
    .required("*Please enter email"),
  phone: Yup.string()
    .matches(number, "please enter a valid")
    .max(12)
    .required("*Please enter phone number"),
  address: Yup.string().required("*please enter the address"),
  designation: Yup.string().required("*please enter  designation"),
  experience: Yup.string().required("*please select  experience"),
  regNumber: Yup.string().required("*please enter  Reg Number"),
});

const AddStaff = () => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);
  const [checkedVale, setCheckedValue] = useState([]);
  const navigate = useNavigate();
  const { layoutRef, institutionId } = useOutletContext();

  const staffAchievmentRef = useRef();
  const staffCertificationRef = useRef();
  const staffEducationRef = useRef();
  const staffEmploymentRef = useRef();
  // const { institutionId } = useOutlet();

  const {
    addStaffPersonalInfo,
    staffPersonalInfo,
    getStaffInfoAction,
    updateStaffAction,
    uploadProfilePicAction,
    addEducationAction,
    addStaffEducationInfo,
    addStaffEmploymentInfo,
    addStaffCertificationInfo,
    addStaffAchievmentsInfo,
    addNewEducation,
    addEmploymentAction,
    addNewEmployment,
    addCertificationAction,
    addNewCertification,
    addAchievementsAction,
    addNewAchievement,
    loading,
    setActiveStaff,
    profileCompleteness,
    resetProfileCompletenessAction,
    resetPersonalInfoAction,
    resetStaffPersonalInfoAction,
  } = useStaff();
  const [edit, setEdit] = useState("");
  const location = useLocation();
  const { getDepartmentAction, departmentData } = useCourse();
  // const [profilePic, setProfilePic] = useState()
  const formikRef = useRef();

  useEffect(() => {
    if (location.pathname === "/staffManagement/editStaff") {
      setEdit(true);
    } else {
      setEdit(false);
      resetProfileCompletenessAction();
      // resetPersonalInfoAction()
      resetStaffPersonalInfoAction();
    }
  }, [location]);

  useEffect(() => {
    getDepartmentAction({
      department: {
        institutionId,
      },
    });
  }, []);

  const handleSubmitForm = (event) => {
    event.stopPropagation();
  };

  useEffect(() => {
    if (formikRef.current) {
      const { setFieldValue } = formikRef.current;
      if (edit) {
        setFieldValue("firstName", staffPersonalInfo?.firstName);
        setFieldValue("lastName", staffPersonalInfo?.lastName);
        setFieldValue("id", staffPersonalInfo?.id);
        setFieldValue("dob", staffPersonalInfo?.dob);
        setFieldValue("bloodGroup", staffPersonalInfo?.bloodGroup);
        setFieldValue("idDepartment", staffPersonalInfo?.idDepartment);
        setFieldValue("email", staffPersonalInfo?.email);
        setFieldValue("phone", staffPersonalInfo?.phone);
        setFieldValue("address", staffPersonalInfo?.address);
        setFieldValue("designation", staffPersonalInfo?.designation);
        setFieldValue("experience", staffPersonalInfo?.experience);
        setFieldValue("idFaculty", staffPersonalInfo?.idFaculty);
        setFieldValue("regNumber", staffPersonalInfo?.regNumber);
      }
    }
  }, [edit, staffPersonalInfo]);

  // useEffect(()=> {
  //   if(edit){
  //     setProfilePic(staffPersonalInfo?.pictureUrl)
  //   }
  // }, [edit,staffPersonalInfo?.pictureUrl])

  const stateValues = {
    firstName: "",
    lastName: "",
    id: "",
    dob: "",
    bloodGroup: "",
    idDepartment: "",
    email: "",
    phone: "",
    address: "",
    designation: "",
    experience: "",
    idFaculty: "",
    regNumber: "",
    institutionId,
  };

  const handleExpand = (panel) => (event, isExpanded) => {
   // setExpanded(isExpanded ? panel : false);

    if (expanded === panel) {
       setExpanded("");
      layoutRef?.current?.scrollTo(0, event.screenY - event.clientY);
    } else {
      if (panel !== 'panel1' && staffPersonalInfo?.id) {
         setExpanded(panel); 
        const ids = Number(panel.replace("panel", ""));

        setTimeout(() => {
          var element = document.getElementById(`ac_${ids}`);
          var offsetTop = element.offsetTop - 80;
          if (layoutRef.current) {
            layoutRef.current.scrollTop = offsetTop;
          }
        }, 500);

        // layoutRef.current.scroll({
        //   left: 0,
        //   top: event.screenY + event.target.clientHeight + 60 - event.clientY,
        // });
      }
      else if (panel === 'panel1') {
        setExpanded(panel); 
        const ids = Number(panel.replace("panel", ""));

        setTimeout(() => {
          var element = document.getElementById(`ac_${ids}`);
          var offsetTop = element.offsetTop - 80;
          if (layoutRef.current) {
            layoutRef.current.scrollTop = offsetTop;
          }
        }, 500);
      }
      else {
        toast.warning('Please Fill In The Staff\'s Personal Information First!', {
          position: toast.POSITION.TOP_RIGHT
        });
      }
    }
  };
  const handleProfile = (e) => {
    if (staffPersonalInfo?.id) {
      // get the files
      let file = e.target.files[0];
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        uploadProfilePicAction({
          facultyProfilePic: {
            idFaculty: staffPersonalInfo.id,
            fileName: e.timeStamp,
            ProfilePicUrl: reader.result.substr(reader.result.indexOf(",") + 1),
          },
        });
      };
    }
  };
  const warningMsg = () => {
    toast.warning('Please Fill In The Student\'s Personal Information First!', {
      position: toast.POSITION.TOP_RIGHT
    }); 
  }

  return (
    <>
      <Grid container spacing={3} className={classes.addStaff_main}>
        <Grid item xl={9} md={12} sm={12}>
          <Stack sx={{ px: 2, flexDirection: "row", justifyContent: "right" }}>
            <Typography
              sx={{
                pr: 2,
                mb: 2,
                // display: status ? "none" : "block",
                transition: "width 0.3s",
              }}
            >
              Back
            </Typography>
            <Stack
              sx={{ cursor: "pointer" }}
              role={"button"}
              onClick={() => navigate("/staffManagement")}
            >
              <img src={logout} alt="logout" />
            </Stack>
          </Stack>
          {edit && (
            <Stack
              sx={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                p: 2,
                mb: 2,
                backgroundColor: "white",
                filter: shadow,
                borderRadius: "23px",
              }}
            >
              <Stack>
                <Typography sx={{ fontWeight: 700, color: "green" }}>
                  Profile Completeness
                </Typography>
              </Stack>
              <Stack
                sx={{ flexDirection: "row", alignItems: "center", gap: 2 }}
              >
                <Typography sx={{ fontWeight: 700, color: "green" }}>
                  StaffID
                </Typography>{" "}
                <Typography sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>
                  {staffPersonalInfo?.regNumber}
                </Typography>
              </Stack>
            </Stack>
          )}
          <Accordion
            expanded={expanded === "panel1"}
            onChange={handleExpand("panel1")}
            sx={{
              mb: 3,
              borderRadius: "23px !important",
              "&.MuiAccordion-root:before": {
                backgroundColor: "white",
              },
              "&.MuiAccordion-root": {
                filter: shadow,
                boxShadow: "none",
              },
              "& .MuiAccordionDetails-root": {
                padding: 0,
              },
            }}
            id="ac_1"
          >
            <AccordionSummary
              sx={{ flexDirection: "row-reverse" }}
              expandIcon={expanded === "panel1" ? <RemoveIcon /> : <AddIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Typography className={classes.heading}>
                Staff Personal Information
              </Typography>

              <>
                <Typography className={classes.secondaryHeading}>
                  {/* Staff ID */}
                </Typography>
                <Stack sx={{ mr: 5 }}>
                  <Button
                    type="submit"
                    form="staffPersonalInfo"
                    sx={{ px: 1, py: 1, borderRadius: "50px" }}
                    className={classes.add_btn}
                    onClick={handleSubmitForm}
                  >
                    {!edit ? "Save" : "Update"}
                  </Button>
                </Stack>
              </>
            </AccordionSummary>
            <Formik
              validationSchema={addStaffDetailsSchema}
              initialValues={stateValues}
              validateOnBlur={false}
              validateOnChange={false}
              enableReinitialize
              innerRef={formikRef}
              onSubmit={(values) => {
                if (!edit) {
                  addStaffPersonalInfo({
                    staffPersonalInfo: {
                      ...values,
                      phone: `${values.phone}`,
                    },
                  });
                } else {
                  updateStaffAction({
                    staffPersonalInfo: {
                      ...values,
                      idRole: "1",
                      pictureUrl: "",
                      phone: `${values.phone}`,
                    },
                  });
                  // getStaffInfoAction({
                  //   idFaculty: staffPersonalInfo.id,
                  // });
                }
              }}
            >
              {(formik) => {
                const {
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  values,
                  setFieldValue,
                } = formik;
                return (
                  <form id="staffPersonalInfo" onSubmit={handleSubmit}>
                    <AccordionDetails>
                      <Grid
                        container
                        columnSpacing={4}
                        rowSpacing={2}
                        sx={{ paddingBottom: "10px", px: 2 }}
                      >
                        <Grid item md={6} sm={12}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 1,
                              // width:'100%'
                            }}
                          >
                            <Typography className={classes.label}>
                              Register number
                            </Typography>
                            <Box>
                              <TextField
                                id="regNumber"
                                name="regNumber"
                                placeholder="Enter Register number"
                                sx={{
                                  width: 220,
                                  display: "flex",
                                }}
                                className={
                                  errors.regNumber && touched.regNumber
                                    ? classes.inputError
                                    : classes.inputNoError
                                }
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.regNumber}
                                disabled={edit}
                              />
                              <ErrorMessage
                                name="regNumber"
                                component="span"
                                className={classes.error}
                              />
                            </Box>
                          </Box>
                        </Grid>
                        <Grid item md={6} sm={12}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 1,
                              // width:'100%'
                            }}
                          >
                            <Typography className={classes.label}>
                              First Name
                            </Typography>
                            <div>
                              <TextField
                                id="firstName"
                                name="firstName"
                                placeholder="Enter First Name"
                                sx={{
                                  width: 220,
                                  display: "flex",
                                }}
                                className={
                                  errors.firstName && touched.firstName
                                    ? classes.inputError
                                    : classes.inputNoError
                                }
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.firstName}
                              />
                              <ErrorMessage
                                name="firstName"
                                component="span"
                                className={classes.error}
                              />
                            </div>
                          </Box>
                        </Grid>
                        <Grid item md={6} sm={12}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 1,
                            }}
                          >
                            <Typography className={classes.label}>
                              Last Name
                            </Typography>
                            <div>
                              <TextField
                                id="lastName"
                                name="lastName"
                                placeholder="Enter Last Name"
                                sx={{
                                  width: 220,
                                  display: "flex",
                                }}
                                className={
                                  errors.lastName && touched.lastName
                                    ? classes.inputError
                                    : classes.inputNoError
                                }
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.lastName}
                              />
                              <ErrorMessage
                                name="lastName"
                                component="span"
                                className={classes.error}
                              />
                            </div>
                          </Box>
                        </Grid>
                        <Grid item md={6} sm={12}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 1,
                            }}
                          >
                            <Typography className={classes.label}>
                              Date of birth
                            </Typography>
                            <div>
                              <TextField
                                id="dob"
                                type="date"
                                name="dob"
                                sx={{
                                  width: 220,
                                  display: "flex",
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                placeholder="Enter Date of birth"
                                className={
                                  errors.dob && touched.dob
                                    ? classes.inputError
                                    : classes.inputNoError
                                }
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values && values.dob}
                              />
                              <ErrorMessage
                                name="dob"
                                component="span"
                                className={classes.error}
                              />
                            </div>
                          </Box>
                        </Grid>

                        <Grid item md={6} sm={12}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 1,
                            }}
                          >
                            <Typography
                              className={classes.label}
                              // sx={{
                              //   paddingTop: "20px",
                              //   letterSpacing: "0px !important"
                              // }}
                            >
                              Blood Group
                            </Typography>
                            {/* <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  paddingLeft: "40px",
                                }}> */}
                            <div>
                              <Select
                                id="bloodGroup"
                                name="bloodGroup"
                                placeholder="Blood Group"
                                sx={{
                                  width: 220,
                                  display: "flex",
                                }}
                                defaultValue=""
                                IconComponent={CustomExpandMore}
                                displayEmpty
                                className={
                                  errors.bloodGroup && touched.bloodGroup
                                    ? classes.inputError
                                    : classes.inputNoError
                                }
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.bloodGroup}
                              >
                                <MenuItem value="" disabled>
                                  Select Blood Group
                                </MenuItem>
                                <MenuItem value="A+">A+</MenuItem>
                                <MenuItem value="A-">A-</MenuItem>
                                <MenuItem value="B+">B+</MenuItem>
                                <MenuItem value="B-">B-</MenuItem>
                                <MenuItem value="O+">O+</MenuItem>
                                <MenuItem value="O-">O-</MenuItem>
                                <MenuItem value="AB+">AB+</MenuItem>
                                <MenuItem value="AB-">AB-</MenuItem>
                                <MenuItem value="A1+-">A1+</MenuItem>
                                <MenuItem value="A2+">A2+</MenuItem>
                                <MenuItem value="A1B+">A1B+</MenuItem>
                              </Select>
                              <ErrorMessage
                                name="bloodGroup"
                                component="span"
                                className={classes.error}
                              />
                            </div>
                          </Box>
                        </Grid>
                        <Grid item md={6} sm={12}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 1,
                            }}
                          >
                            <Typography className={classes.label}>
                              Department ID
                            </Typography>
                            <div>
                              <Select
                                id="idDepartment"
                                name="idDepartment"
                                placeholder="Enter Department ID"
                                sx={{
                                  width: 220,
                                  display: "flex",
                                }}
                                defaultValue=""
                                IconComponent={CustomExpandMore}
                                displayEmpty
                                className={
                                  errors.idDepartment && touched.idDepartment
                                    ? classes.inputError
                                    : classes.inputNoError
                                }
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.idDepartment}
                              >
                                <MenuItem value="" disabled>
                                  Select Department ID
                                </MenuItem>
                                {departmentData.map((_el, index) => (
                                  <MenuItem value={_el.id} key={index}>
                                    {_el.name}
                                  </MenuItem>
                                ))}
                              </Select>

                              <ErrorMessage
                                name="idDepartment"
                                component="span"
                                className={classes.error}
                              />
                            </div>
                          </Box>
                        </Grid>
                        <Grid item md={6} sm={12}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 1,
                            }}
                          >
                            <Typography className={classes.label}>
                              Email
                            </Typography>
                            <Box>
                              <TextField
                                id="email"
                                name="email"
                                placeholder="Enter Email Address"
                                sx={{
                                  width: 220,
                                  display: "flex",
                                }}
                                className={
                                  errors.email && touched.email
                                    ? classes.inputError
                                    : classes.inputNoError
                                }
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.email}
                              />
                              <ErrorMessage
                                name="email"
                                component="span"
                                className={classes.error}
                              />
                            </Box>
                          </Box>
                        </Grid>
                        <Grid item md={6} sm={12}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 1,
                            }}
                          >
                            <Typography
                              className={classes.label}
                              sx={{
                                paddingTop: "20px",
                                letterSpacing: "0px !important",
                                paddingRight: "0px",
                              }}
                            >
                              Designation
                            </Typography>
                            {/* <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap:"0px",                           
                                  
                                }}> */}
                            <div>
                              <TextField
                                id="designation"
                                name="designation"
                                placeholder="Enter your Designation"
                                sx={{
                                  width: 220,
                                  display: "flex",
                                }}
                                defaultValue=""
                                displayEmpty
                                IconComponent={CustomExpandMore}
                                className={
                                  errors.designation && touched.designation
                                    ? classes.inputError
                                    : classes.inputNoError
                                }
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.designation}
                              >
                                {/* <MenuItem value="" disabled>
                                  Select Designation
                                </MenuItem>
                                <MenuItem value="HOD">HOD</MenuItem>
                                <MenuItem value="Assistant Professor">
                                  Assistant Professor
                                </MenuItem>
                                <MenuItem value="Professor">Professor</MenuItem>
                                <MenuItem value="Lab Assistant">
                                  Lab Assistant
                                </MenuItem> */}
                              </TextField>
                              <ErrorMessage
                                name="designation"
                                component="span"
                                className={classes.error}
                              />
                            </div>
                          </Box>
                        </Grid>

                        <Grid item md={6} sm={12}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 1,
                            }}
                          >
                            <Typography className={classes.label}>
                              Address
                            </Typography>
                            <Box>
                              <TextField
                                id="address"
                                name="address"
                                placeholder="Enter Address"
                                sx={{
                                  width: 220,
                                  display: "flex",
                                }}
                                className={
                                  errors.address && touched.address
                                    ? classes.inputError
                                    : classes.inputNoError
                                }
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.address}
                              />
                              <ErrorMessage
                                name="address"
                                component="span"
                                className={classes.error}
                              />
                            </Box>
                          </Box>
                        </Grid>
                        <Grid item md={6} sm={12}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 1,
                            }}
                          >
                            <Typography className={classes.label}>
                              Mobile
                            </Typography>
                            <Box>
                              <PhoneInput
                                id="phone"
                                name="phone"
                                country={"in"}
                                placeholder="Enter Mobile Number"
                                sx={{
                                  width: 220,
                                  display: "flex",
                                }}
                                className={
                                  errors.phone && touched.phone
                                    ? classes.inputError
                                    : classes.inputNoError
                                }
                                onBlur={handleBlur}
                                onChange={(phone) =>
                                  setFieldValue("phone", phone)
                                }
                                value={values.phone}
                              />
                              <ErrorMessage
                                name="phone"
                                component="span"
                                className={classes.error}
                              />
                            </Box>
                          </Box>
                        </Grid>
                        <Grid item md={6} sm={12}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 1,
                            }}
                          >
                            <Typography className={classes.label}>
                              Experience
                            </Typography>
                            <div>
                              <TextField
                                id="experience"
                                name="experience"
                                placeholder="Enter Experience"
                                type="number"
                                sx={{
                                  width: 220,
                                  display: "flex",
                                }}
                                className={
                                  errors.experience && touched.experience
                                    ? classes.inputError
                                    : classes.inputNoError
                                }
                                InputProps={{
                                  inputProps: { min: 1, max: 100 },
                                }}
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.experience}
                              />
                              <ErrorMessage
                                name="experience"
                                component="span"
                                className={classes.error}
                              />
                            </div>
                          </Box>
                        </Grid>
                        <Grid item md={6} sm={12} sx={{ mt: 1 }}>
                          {/* <Stack sx={{pl:30,alignItems: "center", flexDirection:"row" }}>
                    <CheckBox
                        // checked={selectedValue == _el.id}
                        // onChange={() => handleRadio(_el)}
                        style={{ color: "#25D5A1" }}
                      />
                      SMS Notification
                      </Stack> */}
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </form>
                );
              }}
            </Formik>
          </Accordion>
          <Accordion
            expanded={expanded === "panel2"}
            onChange={handleExpand("panel2")}
            sx={{
              mb: 3,
              borderRadius: "23px !important",
              "&.MuiAccordion-root:before": {
                gap: 4,
                mb: 2,
                backgroundColor: "white",
              },
              "&.MuiAccordion-root": {
                filter: shadow,
                boxShadow: "none",
              },
            }}
            id="ac_2"
          >
            <AccordionSummary
              sx={{ flexDirection: "row-reverse" }}
              expandIcon={expanded === "panel2" ? <RemoveIcon /> : <AddIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
            >
              <Typography className={classes.heading}>
                Education Information
              </Typography>
              <Stack sx={{ mr: 2 }}>
                <Button
                  type="submit"
                  form="addStaffEducation"
                  sx={{ px: 1, py: 1, borderRadius: "50px" }}
                  className={classes.add_btn}
                  disabled={staffPersonalInfo?.id ? false : true}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (staffEducationRef.current) {
                      staffEducationRef.current.handleSubmit();
                      setTimeout(() => {
                        if (staffEducationRef.current.isValid) {
                          addStaffEducationInfo({
                            educationList: addNewEducation,
                          });
                        }
                      }, 200);
                    }
                  }}
                >
                  {!edit ? "Save" : "Update"}
                </Button>
              </Stack>
              <Stack
                sx={{ color: "#25D5A1" }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (staffPersonalInfo?.id) {
                    staffEducationRef?.current?.submitForm();
                    addStaffEducationDetailsSchema
                      .isValid(staffEducationRef?.current?.values)
                      .then((valid) => {
                        if (valid) {
                          addEducationAction();
                        }
                        throw new Error("Please fill previous");
                      })
                      .catch((e) => {
                        staffEducationRef?.current?.validateForm();
                      });
                  }
                }}
              >
                <AddIcon />
              </Stack>
            </AccordionSummary>
            {addNewEducation === undefined || addNewEducation?.length === 0 ? (
              <AddEducationInformation currentIndex={"0"} />
            ) : (
              addNewEducation &&
              addNewEducation?.map((val, index) => (
                <AddEducationInformation
                  key={index}
                  currentIndex={index}
                  staffEducationRef={staffEducationRef}
                />
              ))
            )}
          </Accordion>
          <Accordion
            expanded={expanded === "panel3"}
            onChange={handleExpand("panel3")}
            sx={{
              mb: 3,
              borderRadius: "23px !important",
              "&.MuiAccordion-root:before": {
                backgroundColor: "white",
              },
              "&.MuiAccordion-root": {
                filter: shadow,
                boxShadow: "none",
              },
            }}
            id="ac_3"
          >
            <AccordionSummary
              sx={{ flexDirection: "row-reverse" }}
              expandIcon={expanded === "panel3" ? <RemoveIcon /> : <AddIcon />}
              aria-controls="panel3bh-content"
              id="panel3bh-header"
            >
              <Typography className={classes.heading}>
                Employment History
              </Typography>
              <Stack sx={{ mr: 2 }}>
                <Button
                  type="submit"
                  form="addStaffEmployment"
                  sx={{ px: 1, py: 1, borderRadius: "50px" }}
                  className={classes.add_btn}
                  disabled={staffPersonalInfo?.id ? false : true}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (staffEmploymentRef.current) {
                      staffEmploymentRef.current.handleSubmit();
                      setTimeout(() => {
                        if (staffEmploymentRef.current.isValid) {
                          addStaffEmploymentInfo({
                            employmentHistoryList: addNewEmployment,
                          });
                        }
                      }, 200);
                    }
                  }}
                >
                  {!edit ? "Save" : "Update"}
                </Button>
              </Stack>
              <Stack
                sx={{ color: "#25D5A1" }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (staffPersonalInfo?.id) {
                    staffEmploymentRef?.current?.submitForm();
                    addStaffEmploymentDetailsSchema
                      .isValid(staffEmploymentRef?.current?.values)
                      .then((valid) => {
                        if (valid) {
                          addEmploymentAction();
                        }
                        throw new Error("Please fill previous");
                      })
                      .catch((e) => {
                        staffEmploymentRef?.current?.validateForm();
                      });
                  }
                }}
              >
                <AddIcon />
              </Stack>
            </AccordionSummary>
            {addNewEmployment === undefined ||
            addNewEmployment?.length === 0 ? (
              <AddEmployementInformation currentIndex={"0"} />
            ) : (
              addNewEmployment &&
              addNewEmployment?.map((val, index) => (
                <AddEmployementInformation
                  key={index}
                  currentIndex={index}
                  staffEmploymentRef={staffEmploymentRef}
                />
              ))
            )}
          </Accordion>
          <Accordion
            expanded={expanded === "panel4"}
            onChange={handleExpand("panel4")}
            sx={{
              mb: 3,
              borderRadius: "23px !important",
              "&.MuiAccordion-root:before": {
                backgroundColor: "white",
              },
              "&.MuiAccordion-root": {
                filter: shadow,
                boxShadow: "none",
              },
            }}
            id="ac_4"
          >
            <AccordionSummary
              sx={{ flexDirection: "row-reverse" }}
              expandIcon={expanded === "panel4" ? <RemoveIcon /> : <AddIcon />}
              aria-controls="panel4bh-content"
              id="panel4bh-header"
            >
              <Typography className={classes.heading}>
                Certifications
              </Typography>
              <Stack sx={{ mr: 2 }}>
                <Button
                  type="submit"
                  form="addStaffCertification"
                  sx={{ px: 1, py: 1, borderRadius: "50px" }}
                  className={classes.add_btn}
                  disabled={staffPersonalInfo?.id ? false : true}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (staffCertificationRef.current) {
                      staffCertificationRef.current.handleSubmit();
                      setTimeout(() => {
                        if (staffCertificationRef.current.isValid) {
                          addStaffCertificationInfo({
                            certificationsList: addNewCertification,
                          });
                        }
                      }, 200);
                    }
                  }}
                >
                  {!edit ? "Save" : "Update"}
                </Button>
              </Stack>
              <Stack
                sx={{ color: "#25D5A1" }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (staffPersonalInfo?.id) {
                    staffCertificationRef?.current?.submitForm();
                    addStaffCertificationInfromationSchema
                      .isValid(staffCertificationRef?.current?.values)
                      .then((valid) => {
                        if (valid) {
                          addCertificationAction();
                        }
                        throw new Error("Please fill previous");
                      })
                      .catch((e) => {
                        staffCertificationRef?.current?.validateForm();
                      });
                  }
                }}
              >
                <AddIcon />
              </Stack>
            </AccordionSummary>
            {addNewCertification === undefined ||
            addNewCertification.length === 0 ? (
              <AddCertificationInformation currentIndex={"0"} />
            ) : (
              addNewCertification &&
              addNewCertification?.map((val, index) => (
                <AddCertificationInformation
                  key={index}
                  currentIndex={index}
                  staffCertificationRef={staffCertificationRef}
                />
              ))
            )}
          </Accordion>

          {/* Achievements */}
          <Accordion
            expanded={expanded === "panel5"}
            onChange={handleExpand("panel5")}
            sx={{
              mb: 3,
              borderRadius: "23px !important",
              "&.MuiAccordion-root:before": {
                backgroundColor: "white",
              },
              "&.MuiAccordion-root": {
                filter: shadow,
                boxShadow: "none",
              },
            }}
            id="ac_5"
          >
            <AccordionSummary
              sx={{ flexDirection: "row-reverse" }}
              expandIcon={expanded === "panel5" ? <RemoveIcon /> : <AddIcon />}
              aria-controls="panel5bh-content"
              id="panel5bh-header"
            >
              <Typography className={classes.heading}>Achievements</Typography>
              <Stack sx={{ mr: 2 }}>
                <Button
                  type="submit"
                  form="addStaffAchievments"
                  sx={{ px: 1, py: 1, borderRadius: "50px" }}
                  className={classes.add_btn}
                  disabled={staffPersonalInfo?.id ? false : true}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (staffAchievmentRef.current) {
                      staffAchievmentRef.current.handleSubmit();
                      setTimeout(() => {
                        if (staffAchievmentRef.current.isValid) {
                          addStaffAchievmentsInfo({
                            achievementsList: addNewAchievement,
                          });
                        }
                      }, 2000);
                    }
                  }}
                >
                  {!edit ? "Save" : "Update"}
                </Button>
              </Stack>
              <Stack
                sx={{ color: "#25D5A1" }}
                onClick={(e) => { 
                  e.stopPropagation();
                  if (staffPersonalInfo?.id) {
                    staffAchievmentRef?.current?.submitForm();
                    addCertificationInfromationSchema
                      .isValid(staffAchievmentRef?.current?.values)
                      .then((valid) => {
                        if (valid) {
                          addAchievementsAction();
                        }
                        throw new Error("Please fill previous");
                      })
                      .catch((e) => {
                        staffAchievmentRef?.current?.validateForm();
                      });
                  }
                }}
              >
                <AddIcon />
              </Stack>
            </AccordionSummary>
            {addNewAchievement === undefined ||
            addNewAchievement.length === 0 ? (
              <AddAchivementsInformation currentIndex={"0"} />
            ) : (
              addNewAchievement &&
              addNewAchievement?.map((val, index) => (
                <AddAchivementsInformation
                  key={index}
                  currentIndex={index}
                  staffAchievmentRef={staffAchievmentRef}
                />
              ))
            )}
          </Accordion>
          <Accordion
            expanded={expanded === "panel6"}
            onChange={handleExpand("panel6")}
            sx={{
              mb: 3,
              borderRadius: "23px !important",
              "&.MuiAccordion-root:before": {
                backgroundColor: "white",
              },
              "&.MuiAccordion-root": {
                filter: shadow,
                boxShadow: "none",
              },
            }}
            id="ac_6"
          >
            <AccordionSummary
              sx={{ flexDirection: "row-reverse" }}
              expandIcon={expanded === "panel6" ? <RemoveIcon /> : <AddIcon />}
              aria-controls="panel6bh-content"
              id="panel6bh-header"
            >
              <Typography className={classes.heading}>
                Other interests
              </Typography>
              <Stack sx={{ color: "#25D5A1", mr: 5 }}>
                <Button
                  type="submit"
                  form="addStaffInterest"
                  sx={{ px: 1, py: 1, borderRadius: "50px" }}
                  className={classes.add_btn}
                  disabled={staffPersonalInfo?.id ? false : true}
                  onClick={(e) => {
                    e.stopPropagation(); 
                  }}
                >
                  {!edit ? "Save" : "Update"}
                </Button>
              </Stack>
            </AccordionSummary>
            <OtherIntrestsInformation
              setCheckedValue={setCheckedValue}
              checkedVale={checkedVale}
            />
          </Accordion>
        </Grid>
        <Grid item xl={3} md={12} sm={12}>
          <Stack
            className={classes.profile_card}
            sx={{ justifyContent: "space-evenly" }}
          >
            <Stack
              sx={{
                width: "80px",
                height: "80px",
                "& img": {
                  borderRadius: "50px",
                  width: "100%",
                  height: "100%",
                },
              }}
            >
              <img
                src={
                  (staffPersonalInfo?.pictureUrl &&
                    `${staffPersonalInfo?.pictureUrl}?${Date.now()}`) ||
                  Profile
                }
                alt="profile"
              />
            </Stack>

            <Stack sx={{ textAlign: "center", py: 2 }}>
              {staffPersonalInfo?.firstName && staffPersonalInfo?.lastName ? (
                <Typography sx={{ color: "black", fontWeight: "500" }}>
                  {staffPersonalInfo?.firstName +
                    " " +
                    staffPersonalInfo?.lastName}
                </Typography>
              ) : (
                <Typography sx={{ color: "black", fontWeight: "500" }}>
                  Staff Name
                </Typography>
              )}
              <Stack sx={{ textAlign: "center", my: 1 }}>
                {staffPersonalInfo?.regNumber ? (
                  <Typography sx={{ color: "#8083A3" }}>
                    {staffPersonalInfo?.regNumber}
                  </Typography>
                ) : (
                  <Typography sx={{ color: "#8083A3" }}></Typography>
                )}
              </Stack>

              <Button
                component="label"
                className={classes.upload_photo}
                variant="outlined"
                sx={{ marginRight: "1rem" }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (!staffPersonalInfo?.id) {
                    warningMsg();
                  }  
                }}
              >
                Upload Photo
                {
                  (!staffPersonalInfo?.id) ? (<input type="file" hidden disabled />)
                    :
                    (
                      <input type="file"
                    // accept="image/png,image/gif,image/jpeg"
                        hidden onChange={(e) => handleProfile(e)} />
                    )
                  
                }
              </Button>
            </Stack>

            <Stack
              sx={{
                width: "80%",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                background: "#F6FEF9",
                p: 2,
                borderRadius: "12px",
              }}
            >
              <Stack
                sx={{
                  color: "green",
                  width: "40px",
                  height: "40px",
                  borderRadius: "50px",
                  background: "#D1FADF",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <PersonIcon />
              </Stack>
              <Stack sx={{ width: "80%" }}>
                <Stack
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: "row",
                  }}
                >
                  <Typography sx={{ color: "#054F31", fontWeight: 500 }}>
                    Profile Complete
                  </Typography>
                  <Typography sx={{ color: "#027A48" }}>
                    {profileCompleteness}%
                  </Typography>
                </Stack>
                <BorderLinearProgress
                  variant="determinate"
                  value={profileCompleteness}
                  sx={{ my: 1 }}
                />
              </Stack>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default AddStaff;
